module.exports = __webpack_public_path__ + "img/google-play-badge-de.8c087b43.png";